import type { IUser } from '../types/i-user';
import { fetchUserById } from './fetch-user-by-id';

export type IUserMap = Record<string, Pick<IUser, 'id' | 'name' | 'email' | 'image'>>;

export async function fetchUsersByIds(cookieHeader: string, userIds: string[]): Promise<IUserMap> {
  const uniqueIds = [...new Set(userIds.filter(Boolean))];
  const results = await Promise.all(uniqueIds.map((id) => fetchUserById(cookieHeader, id)));

  const userMap: IUserMap = {};
  for (let i = 0; i < uniqueIds.length; i++) {
    const user = results[i];
    const id = uniqueIds[i];
    if (user && id) {
      userMap[id] = {
        id: user.id,
        name: user.name,
        email: user.email,
        image: user.image,
      };
    }
  }
  return userMap;
}
